<template>
  <div id="big" :class="{loading:isBigActive}" ref="myBig">
    <div id="masks_L" @mouseover="handleLeftOver" @mouseout="handleLeftOut"></div>
    <div id="masks_R" @mouseover="hanldeRightOver" @mouseout="handleRightOut"></div>
    <div ref="btnL" id="btn_L" @mouseover="handleLeftOver" @mouseout="handleLeftOut" @click="handleLeftClick"></div>
    <div ref="btnR" id="btn_R" @mouseover="hanldeRightOver" @mouseout="handleRightOut" @click="handleRightClick"></div>
    <div id="title" ref="myTitle"><span ref="mySpan"></span></div>
  </div>
</template>
<script>
function getStyle(obj,attr){return obj.currentStyle ? obj.currentStyle[attr] : getComputedStyle(obj,null)[attr]}
export default {
  data(){
    return{
      iNow:0,
      isbtnLShow:false,
      isbtnRShow:false,
      isBigActive:false,
      imgdata:[
        {'imgSrc':'http://img1.gtimg.com/news/pics/hv1/106/238/825/53706421.jpg','title':'7月26日，吊车将事故现场的车头残片吊至大型运输车辆上。'},
        {'imgSrc':'http://img1.gtimg.com/news/pics/hv1/105/238/825/53706420.jpg','title':'7月26日，一辆大卡车准备驶离事故现场。'},
        {'imgSrc':'http://img1.gtimg.com/news/pics/hv1/101/238/825/53706416.jpg','title':'7月26日，工人在给最后一节车厢盖上彩条布，准备运离现场。'},
        {'imgSrc':'http://img1.gtimg.com/news/pics/hv1/99/238/825/53706414.jpg','title':'7月26日，一名工人在事故现场最后一节车厢上作业。'},
        {'imgSrc':'http://img1.gtimg.com/news/pics/hv1/100/238/825/53706415.jpg','title':'7月26日，工人在给最后一节车厢盖上彩条布，准备运离现场。'}
      ]
    }
  },
  methods:{
    handleLeftOver(){
      this.startMOve(this.$refs.btnL,'opacity',100);
      //this.isbtnLShow=true;
    },
    handleLeftOut(){
      this.startMOve(this.$refs.btnL,'opacity',0);
      //this.isbtnLShow=false;
    },
    hanldeRightOver(){
      this.startMOve(this.$refs.btnR,'opacity',100);
      //this.isbtnRShow=true;
    },
    handleRightOut(){
      this.startMOve(this.$refs.btnR,'opacity',0);
      //this.isbtnRShow=false;
    },
    startMOve(obj,attr,iTarget,fnEnd){
      var _this=this;
      clearInterval(obj.timer);
      obj.timer=setInterval(() => {
        _this.doMove(obj,attr,iTarget,fnEnd);
      }, 20);
    },
    doMove(obj,attr,iTarget,fnEnd){
                var iCur = parseFloat(getStyle(obj, attr));
                if (attr == "opacity") {
                    iCur = parseInt(iCur * 100)
                }
                var iSpeed = (iTarget - iCur) / 5;
                iSpeed = iSpeed > 0 ? Math.ceil(iSpeed) : Math.floor(iSpeed);

                if (iTarget == iCur) {
                    clearInterval(obj.timer);
                    fnEnd && fnEnd();
                }
                else {
                    if (attr == "opacity") {
                        obj.style.filter = "alpha(opacity = " + (iCur + iSpeed) + ")";
                        obj.style.opacity = (iCur + iSpeed) / 100;
                    }
                    else {
                        obj.style[attr] = iCur + iSpeed + "px";
                    }
                }
    },
    handleLeftClick(){
      if(this.iNow <= 0){
        alert('前面没有图片了！');
        return;
      }
      this.iNow--;
      this.loadImg();
    },
    handleRightClick(){
      if(this.iNow >= this.imgdata.length -1){
        alert('这是最后一张图片了！');
        return;
      }
      this.iNow++;
      this.loadImg();
    },
    loadImg(){
      var _this =this;
      this.isBigActive=true;
      var myBig=this.$refs.myBig;
      var myTitle=this.$refs.myTitle;
      var mySpan=this.$refs.mySpan;
      mySpan.style.opacity=myTitle.style.height=0;
      var oImg=myBig.getElementsByTagName('img');
      oImg[0] && myBig.removeChild(oImg[0]);
      var oTemp = document.createElement('img');
      var oNewImg=new Image();
      oNewImg.onload=function(){
        _this.isBigActive=false;
        oTemp.src=oNewImg.src;
        myBig.appendChild(oTemp);
        oTemp.style.width = (oTemp.offsetWidth > 800 ? 800 : oTemp.offsetWidth) + 'px';
        myBig.style.height = oTemp.style.height = oTemp.offsetHeight * oTemp.offsetWidth / oTemp.offsetWidth + 'px';
        //console.log(_this.imgdata);
        mySpan.innerHTML=_this.imgdata[_this.iNow].title;
        _this.startMOve(myTitle,'height',50,function(){
          _this.startMOve(myTitle.childNodes[0],'opacity',100);
        })
      };
      oNewImg.src=this.imgdata[this.iNow].imgSrc;
    }
  },
  mounted(){
    this.loadImg();
  }
}
</script>
<style>
body, div, ul, li{
  margin: 0;
  padding: 0;
}
li{
  list-style: none;
}
body{
  font: 12px/1.5 \5fae\8f6f\96c5\9ed1;
  background:#000;
}
#big{
  position: relative;
  width: 800px;
  height: auto !important;
  height: 400px;
  min-width: 400px;
  margin: 20px auto;
  text-align: center;
}
#title{
  position: absolute;
  top:0;
  left: 0;
  width: 100%;
  background: #000;
  color: #fff;
  opacity: 0.7;
  filter: alpha(opacity=70);
  font-size: 20px;
  height: 50px;
}
#title span{
  padding: 0 50px;
  line-height: 50px;
  display: block;
}
#big.loading{
  background: url(./assets/lesson7/loading.gif) 50% 50% no-repeat;
}
#masks_L, #masks_R{
  position: absolute;
  top:0;
  width: 400px;
  height: 100%;
  cursor: pointer;
  background: #f0f0f0;
  opacity: 0;
  filter: alpha(opacity=0);
}
#masks_L{
  left: 0;
}
#masks_R{
  right: 0;
}
#btn_L, #btn_R{
  position: absolute;
  top:50%;
  margin-top: -40px;
  width: 39px;
  height: 80px;
  overflow: hidden;
  cursor: pointer;
  text-indent: -9999px;
  background:url(./assets/lesson7/btn.png) no-repeat;
  opacity: 0;
  filter: alpha(opacity=0);
}
#btn_L{
  left: 10px;
  background-position: 0 0;
}
#btn_R{
  right: 10px;
  background-position: -39px 0;
}
</style>